export default "__VITE_ASSET__37540a40__"